import { render, staticRenderFns } from "./InvoiceDocumentSidebar.vue?vue&type=template&id=6a725f10&scoped=true&"
import script from "./InvoiceDocumentSidebar.vue?vue&type=script&lang=js&"
export * from "./InvoiceDocumentSidebar.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceDocumentSidebar.vue?vue&type=style&index=0&id=6a725f10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a725f10",
  null
  
)

export default component.exports